import { PropertyLookupDetail } from '../../shared/models/property-lookup-detail';
import { FormGroup } from '@angular/forms';
import { PropertyLookupStore } from '../../shared/lookup/property-lookup/property-lookup.store';
import { Property } from '../models/property';
import { Party } from '../models/party';
import { PartyType } from '../models/party-type';

export class PropertyLookupConverter {

  static updateFormFields(detail: PropertyLookupDetail,
                          contactLookupForm: FormGroup,
                          propertyLookupStore: PropertyLookupStore) {

    contactLookupForm.patchValue({
      name: detail.name,
      line1: detail.address.line1,
      line2: detail.address.line2,
      city: detail.address.city,
      state: detail.address.state,
      postalCode: detail.address.postalCode,
      propertyId: detail.propertyId,
      chain: detail.chain,
      brand: detail.brand,
      countryCode: detail.address.countryCode,
      manuallyAdded: detail.manuallyAdded
    });
    contactLookupForm.controls[ 'contact' ].patchValue({
      firstName: detail.contact.firstName,
      lastName: detail.contact.lastName,
      email: detail.contact.email,
      phone: detail.contact.phone,
      fax: detail.contact.fax
    });


    contactLookupForm.controls[ 'propertyNameSearch' ].setValue('');
    propertyLookupStore.clearSearchResults();
  }

  /**
   * Convert a Property into Party
   *
   * @param property Property object
   * @param autoGeneratedCode boolean
   * @param manuallyAdded boolean
   * @returns {Party}
   */
  static propertyToParty(property: Property, autoGeneratedCode: boolean): Party {
    return new Party({
      eventPartyId: null,
      version: null,
      createdDate: null,
      modifiedDate: null,
      chain: property.chain,
      brand: property.brand,
      propertyId: property.pid,
      agencyId: null,
      clientReferenceNumber: null,
      partyType: PartyType.PROPERTY,
      code: null,
      name: property.name,
      dbaName: null,
      countryCode: property.countryCode,
      eventId: null,
      line1: property.address1,
      line2: property.address2,
      line3: property.address3,
      city: property.city,
      state: property.stateProvinceCode,
      postalCode: property.postalCode,
      eventReferenceNumber: null,
      autoGeneratedCode: autoGeneratedCode,
      manuallyAdded: property.manuallyAdded,
      contact: {
        eventContactId: null,
        version: null,
        createdDate: null,
        modifiedDate: null,
        partyType: PartyType.PROPERTY,
        eventId: null,
        firstName: property.contactFirstNm,
        lastName: property.contactLastNm,
        email: property.email,
        phone: property.phoneNr,
        fax: property.faxNr
      },
      subscriber: property.subscriber
    });
  }

  static convertPropertyLookupDetailToProperty(propertyLookupDetail: PropertyLookupDetail): Property {
    return new Property({
      chain: propertyLookupDetail.chain,
      brand: propertyLookupDetail.brand,
      pid: propertyLookupDetail.propertyId,
      name: propertyLookupDetail.name,
      address1: propertyLookupDetail.address ? propertyLookupDetail.address.line1 : null,
      address2: propertyLookupDetail.address ? propertyLookupDetail.address.line2 : null,
      address3: propertyLookupDetail.address ? propertyLookupDetail.address.line3 : null,
      city: propertyLookupDetail.address ? propertyLookupDetail.address.city : null,
      stateProvinceCode: propertyLookupDetail.address ? propertyLookupDetail.address.state : null,
      countryCode: propertyLookupDetail.address ? propertyLookupDetail.address.countryCode : null,
      postalCode: propertyLookupDetail.address ? propertyLookupDetail.address.postalCode : null,
      phoneNr: propertyLookupDetail.contact ? propertyLookupDetail.contact.phone : null,
      faxNr: propertyLookupDetail.contact ? propertyLookupDetail.contact.fax : null,
      email: propertyLookupDetail.contact ? propertyLookupDetail.contact.email : null,
      contactFirstNm: propertyLookupDetail.contact ? propertyLookupDetail.contact.firstName : null,
      contactLastNm: propertyLookupDetail.contact ? propertyLookupDetail.contact.lastName : null,
      subscriber: propertyLookupDetail.subscriber,
      manuallyAdded: propertyLookupDetail.manuallyAdded
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/utils/property-lookup-converter.ts